<template>

  <ion-page id="legacy-master-page">

    <AlertReplacement :alertInfo="alertInfo" :trigger="alertTrigger"
              @alert-result="alertResult"></AlertReplacement>

    <ion-content>

      <div v-show="showTour">
        <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
      </div>

      <div id="the_board" v-show="showState == SHOW_EXPLORER || showState == SHOW_GAMELIST"
                :style="styleBoard">
                  <CMChessboard :fen="fen" :validMoves="availableMoves" :orientation="orientation" 
                    :boardSize="boardSize" @board-move="boardMove" />
      </div>

      <div v-show="showState == SHOW_EXPLORER">
        <div id="the_movelist">
          <div 
                  :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleMoveList">
            <MoveList :resultsData="availableMoves" :eighty="eighty" :showScores="showScores" 
             :showCheckboxes=showMoveListCheckboxes
            :singleSelection=singleSelection   
            @movelist-click="movelistClick" @checkbox-click="moveListCheckboxClick"/>
          </div>
        </div>

        <div :style="styleMoveHistory" :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
          <MoveHistory :moveHistoryStack="moveHistoryStack" :trigger="moveHistoryTrigger" 
                    @move-history-string="moveHistoryStringUpdate" />
        </div>
    
        <div id="the_playerlist" :style="stylePlayerList" 
                  :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">

          <!-- <PlayerList :playerList="players" :playerListTrigger="playerListTrigger" /> -->

          <PlayerListAgGrid :playerList="players" :playerListTrigger="playerListTrigger" 
                :showPlayerCheckboxes="showPlayerCheckboxes"
                :playerNameHeadingString="playerNameHeadingString"
                :setOneCellValue="setOneCellValue"
                :styleHeight="stylePlayerListAgHeight"
                @player-click="playerClick"/>

        </div>
      </div>

      <div id="the_gamelist" v-show="showState == SHOW_GAMELIST">
    
        <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleGameList">
          <GameListAgGrid :gameList="games" :gameListTrigger="gameListTrigger" 
                :styleHeight="styleGameListAgHeight"
                @game-click="gameClick"/>
        </div>
        <div id="game-event-container" :style="styleGameEvent" :class="{        
                      'reptree-container-background-light' : !isDark,
                      'reptree-container-background-dark' : isDark,
                      'text-dark' : isDark, 'text-light' : !isDark }">
          <div class="game-review-event"><i>{{ oneGameEvent }}</i></div>
          <div class="game-review-score"><b>{{ oneGameScore }}</b></div>
        </div>
        <div :style="styleGameViewer" :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
          <GameReview :gameMoves="oneGameMoves" :moveDirection="directionTrigger"
                @move-click="gameMoveClick" />
        </div>
      </div>
    </ion-content>

    <Toolbar id="the_toolbar2" :ignoreClicks="showTour" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonItem, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';
  import { t } from '@/composables/translateText.js'

  import CMChessboard from '@/components/CMChessboard.vue'
  import MoveList from '@/components/MoveList.vue'
  import Toolbar from '@/components/Toolbar.vue'
  import MoveHistory from '@/components/MoveHistory.vue'
  import PlayerList from '@/components/PlayerList.vue'
  import PlayerListAgGrid from '@/components/PlayerListAgGrid.vue'
  import GameListAgGrid from '@/components/GameListAgGrid.vue'
  import GameReview from '@/components/GameReview.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import AlertReplacement from '@/components/AlertReplacement.vue'

  import { ref, watch } from 'vue'
  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'
  import { useGetData , useGetDataDownload } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { onMounted, onBeforeUnmount } from 'vue'

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import Tour from '@/components/Tour.vue'

  const alertInfo = ref({})
  const alertTrigger = ref(0)

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  const showTour = ref((tourOption == "show"))
  
  const TOOLBAR_FLIP = 0
  const TOOLBAR_BACK = 1
  const TOOLBAR_REWIND = 2
  const TOOLBAR_GOTO_GAMELIST = 3

  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

  const MOVEHISTORY_FONTSIZE = 16
  const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 * 2 + 4

  const toolbarMainElements = [
    { index : TOOLBAR_FLIP, label : t("Flip") ,disabled : false, collapse:false},
    { index : TOOLBAR_BACK, label : "<" , disabled : true, collapse:false},
    { index : TOOLBAR_REWIND, label : "<<" , disabled : true, collapse:false},
    { index : TOOLBAR_GOTO_GAMELIST, label : t("Games"), disabled : true, collapse:true}
    ]
    

  const TOOLBAR_GAMELIST_DONE = 0
  const TOOLBAR_GAMELIST_FLIP = 1
  const TOOLBAR_GAMELIST_BACK = 2
  const TOOLBAR_GAMELIST_FORWARD = 3
  const TOOLBAR_GAMELIST_DOWNLOAD = 4
  const TOOLBAR_GAMELIST_SCORE = 5

  const toolbarElementsGameList = [
    { index : TOOLBAR_GAMELIST_FLIP, label : t("Flip") ,disabled : false, collapse:true},
    { index : TOOLBAR_GAMELIST_BACK, label : "<" , disabled : true, collapse:false},
    { index : TOOLBAR_GAMELIST_FORWARD, label : ">" , disabled : true, collapse:false},
    { index : TOOLBAR_GAMELIST_SCORE, label : t("Score Game") ,disabled : true, collapse:true},
    { index : TOOLBAR_GAMELIST_DOWNLOAD, label : t("Download") ,disabled : false, collapse:true},
    { index : TOOLBAR_GAMELIST_DONE, label : t("Done") ,disabled : false, collapse:false},
  ]

  const toolbarElements = ref(toolbarMainElements)

  const TOOLBAR_GAMELIST_DOWNLOAD_CURRENT = 10
  const TOOLBAR_GAMELIST_DOWNLOAD_ALL = 11
  const TOOLBAR_GAMELIST_DOWNLOAD_FEN = 12
  
  const SHOW_EXPLORER = 0
  const SHOW_GAMELIST = 2
  const showState = ref(SHOW_EXPLORER)

  // set to zero to get the player names the first time
  var fenid = 0
  var playerNames = []
  var selectedPlayerId = 0
  var selectedPlayerName = ""

  var useAllGames = true

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  //console.log("**** explorer initial screensize", windowSizeRef.value)
  const boardSize = ref(100)

  const fen = ref(INITIAL_FEN)
  const eighty = ref(-2)
  const showScores = ref(true)
  const showMoveListCheckboxes = ref("yes")

  var playingWhite = 1
  var blankAppendTrigger = " "
  var orientation = ref("white")

  const availableMoves = ref([])
  const moveHistoryStack = ref([])
  const moveHistoryTrigger = ref(0)
  const toolbarTrigger = ref(0)
  const toolbarGameListTrigger = ref(0)

  // saved state for when coming back from "done" on gamelist
  var savedAvailableMoves = []
  var boardOrientation = "white"
  var savedFen = ""

  const players = ref([])
  const playerListTrigger = ref(0)
  const playerNameHeadingString = ref("Playing All Moves")
  const showPlayerCheckboxes = ref(true)
  const setOneCellValue = ref([])

  var moveHistoryString = ""
  var selectedSan = ""
  var selectedFen = ""
  var selectedFenid = 0
  var selectedPlayer = ""
  var saveJsonResponseFromServer = null
  const singleSelection = ref(true)

  // save the json that came when nothing is selected. will need it frequently
  var nothingSelectedJson = null 

  // for gamelist
  const gameListTrigger = ref(0)
  const games = ref([])
  const oneGameMoves = ref([])
  const oneGameEvent = ref("")
  const oneGameScore = ref("")
  var oneGameMoveIndex = -1
  var directionTriggerCounter = 1
  const directionTrigger = ref(1)
  var oneGamePlayingWhite = 1
  var oneGameID = 0
  var oneGameWhiteName = ""
  var oneGameBlackName = ""
  var scoreCount = 0
  var plyCount = 0
  var CalcScoreSeconds = 0
  var timerCanStop = false

  // from the gamelist server grab, save it to make it easy to pass to the game pgn download
  var gamelistIdArray = []

  const stylePlayerListAgHeight = ref("height: 300px")
  const styleGameListAgHeight = ref("height: 300px")

  // tour stuff
  const tourInfo = ref({
    id : "opening_master",
    video : "https://www.chessvis.com/videos/master_player_web.mp4",
    elements : [
      { id: "", title: t("Master Player Explorer"), text : t("Ever wonder which top players play your favorite opening?")},
      { id: "the_movelist", title: t("The Move List"), text : t("Check the box next to a move and the player list below will be updated to show the players who play that move.")},
      { id: "the_playerlist", title: t("The Player List"), text : t("Check the box next to the player's name and the move list above will be updated to reflect what that player plays.")},
      { id: "the_playerlist", title: t("Player List Filters"), text : t("Clicking on a column heading will sort it. Clicking on the 3 bars next to the name will enable you to filter the list.")},
      { id: "the_toolbar", title: t("Game List - Toolbar"), text : t("If you select a player, this option will bring up a secondary screen where you see a list of the games. There you can review a game or download them.")}
    ]
  })

  const styleMoveList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleMoveHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1.2em"
  })

  const stylePlayerList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleGameList = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleGameEvent = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleGameViewer = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  function afterStartupCallbackRoutine(stuffChanged) {

    updateWidthHeights()
    getMoves(0,0)
    menuTrigger.value++
  }

  onMounted(() => {
    //console.log("explorer mounted")
    //getMoves(0,0)
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  // https://www.30secondsofcode.org/articles/s/copy-text-to-clipboard-with-javascript

  const copyToClipboard = str => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"
    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleMoveList.value.height = boundaries['moveList'].height + "px"
    styleMoveList.value.width = boundaries['moveList'].width + "px"
    styleMoveList.value.top = boundaries['moveList'].top + "px"
    styleMoveList.value.left = boundaries['moveList'].left + "px"

    styleMoveHistory.value.height = boundaries['history'].height + "px"
    styleMoveHistory.value.width = boundaries['history'].width + "px"
    styleMoveHistory.value.top = boundaries['history'].top + "px"
    styleMoveHistory.value.left = boundaries['history'].left + "px"

    stylePlayerList.value.height = boundaries['playerList'].height + "px"
    stylePlayerList.value.width = boundaries['playerList'].width + "px"
    stylePlayerList.value.top = boundaries['playerList'].top + "px"
    stylePlayerList.value.left = boundaries['playerList'].left + "px"

    stylePlayerListAgHeight.value = "height: " + boundaries['playerList'].height + "px"

    // for Game List

    styleGameList.value.height = boundaries['gameList'].height + "px"
    styleGameList.value.width = boundaries['gameList'].width + "px"
    styleGameList.value.top = boundaries['gameList'].top + "px"
    styleGameList.value.left = boundaries['gameList'].left + "px"

    styleGameListAgHeight.value = "height: " + boundaries['gameList'].height + "px"

    styleGameViewer.value.height = boundaries['gameViewer'].height + "px"
    styleGameViewer.value.width = boundaries['gameViewer'].width + "px"
    styleGameViewer.value.top = boundaries['gameViewer'].top + "px"
    styleGameViewer.value.left = boundaries['gameViewer'].left + "px"

    styleGameEvent.value.height = boundaries['gameEvent'].height + "px"
    styleGameEvent.value.width = boundaries['gameEvent'].width + "px"
    styleGameEvent.value.top = boundaries['gameEvent'].top + "px"
    styleGameEvent.value.left = boundaries['gameEvent'].left + "px"

    //console.log("**** boardsize ",boardSize.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {
    // reserve space for the instruction lines
    const availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height/2,
                isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const historyPositionTop = boardPositionTop + boardHeight
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = MOVEHISTORY_HEIGHT
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const moveListPositionTop = historyPositionTop + historyHeight
    const moveListPositionLeft = availableSpace.leftRightIndent
    const moveListHeight = (availableSpace.height - moveListPositionTop) / 2
    const moveListWidth = historyWidth

    const playerListPositionTop = moveListPositionTop + moveListHeight
    const playerListPositionLeft = availableSpace.leftRightIndent
    const playerListHeight = (availableSpace.height - playerListPositionTop)
    const playerListWidth = historyWidth

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      moveList : {
        width : moveListWidth,
        height : moveListHeight,
        left : moveListPositionLeft + availableSpace.leftIndent,
        top : moveListPositionTop + availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop + availableSpace.topIndent
      },
      playerList : {
        width : playerListWidth,
        height : playerListHeight,
        left : playerListPositionLeft + availableSpace.leftIndent,
        top : playerListPositionTop + availableSpace.topIndent
      },

      gameList : {
        width : moveListWidth,
        height : moveListHeight,
        left : moveListPositionLeft + availableSpace.leftIndent,
        top : moveListPositionTop + availableSpace.topIndent
      },
      gameEvent : {
        width : playerListWidth,
        height : 20,
        left : playerListPositionLeft + availableSpace.leftIndent,
        top : playerListPositionTop + availableSpace.topIndent
      },
      gameViewer : {
        width : playerListWidth,
        height : playerListHeight -20,
        left : playerListPositionLeft + availableSpace.leftIndent,
        top : playerListPositionTop + availableSpace.topIndent
      }

    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    // reserve space for the instruction lines
    const availableSpaceForBoard = { width : availableSpace.width/2,
                height : availableSpace.height - MOVEHISTORY_HEIGHT,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const moveListPositionTop = 0
    const moveListPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const moveListHeight = (availableSpace.height - MOVEHISTORY_HEIGHT) / 2
    const moveListWidth = availableSpace.width - moveListPositionLeft

    const playerListPositionTop = moveListPositionTop + moveListHeight
    const playerListPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const playerListHeight = availableSpace.height - MOVEHISTORY_HEIGHT - moveListHeight
    const playerListWidth = availableSpace.width - playerListPositionLeft

    const historyPositionTop = availableSpace.height  - MOVEHISTORY_HEIGHT
    const historyPositionLeft = availableSpace.leftRightIndent
    const historyHeight = MOVEHISTORY_HEIGHT
    const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      moveList : {
        width : moveListWidth,
        height : moveListHeight,
        left : moveListPositionLeft + availableSpace.leftIndent,
        top : moveListPositionTop + availableSpace.topIndent
      },
      history : {
        width : historyWidth,
        height : historyHeight,
        left : historyPositionLeft + availableSpace.leftIndent,
        top : historyPositionTop + availableSpace.topIndent
      },
      playerList : {
        width : playerListWidth,
        height : playerListHeight,
        left : playerListPositionLeft + availableSpace.leftIndent,
        top : playerListPositionTop + availableSpace.topIndent
      },
      gameList : {
        width : moveListWidth,
        height : moveListHeight,
        left : moveListPositionLeft + availableSpace.leftIndent,
        top : moveListPositionTop + availableSpace.topIndent
      },
      gameViewer : {
        width : playerListWidth,
        height : playerListHeight -20 ,
        left : playerListPositionLeft + availableSpace.leftIndent,
        top : playerListPositionTop + 20 + availableSpace.topIndent
      },
      gameEvent : {
        width : playerListWidth,
        height : 20,
        left : playerListPositionLeft + availableSpace.leftIndent,
        top : playerListPositionTop + availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  // builds move string adding the possible clicked on move that isn't on the stack "yet"
  function buildMoveString(MoveStack,extraSan) {
    var moveString = ""
    var moveNumber = 1
    var moveIsWhite = true

    for (var i=0; i < MoveStack.length; i++) {
      if (moveIsWhite) {
        if (moveNumber > 1)
          moveString += " "
        moveString += moveNumber + "."
        moveNumber++
      }
      moveString += " " + MoveStack[i].san
      moveIsWhite = !moveIsWhite
    }

    if (extraSan == "")
      return (moveString)

    if (moveIsWhite) {
      if (moveNumber > 1)
        moveString += " "
      moveString += moveNumber + "."
    }
    moveString += " " + extraSan
    return (moveString)
  }

  function moveHistoryStringUpdate(moveString) {
    //console.log("Move history String ",moveString)
    moveHistoryString = moveString
  }

  function zapToolbarCheckMark(index) {
    var element = findToolbarElement(toolbarElements.value,TOOLBAR_FILTER)
    for (var i = 0; i < element.submenu.length; i++)
          element.submenu[i].checked =
              (element.submenu[i].index == index) 
  }

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function alertResult(response,task,info) {
    //console.log("Alert Result",response,task)

    if (response == "no")
      return

    switch (response) {
      case "no" :
        return
      case "all" :
        getDownloadPgn(0,selectedPlayerName + "_" + moveHistoryString + " " + selectedSan)
        break
      case "current" :
        getDownloadPgn(oneGameID,oneGameWhiteName + "_" + oneGameBlackName)
        break
      case "fen" :
        navigator.clipboard.writeText(fen.value)
        oneGameScore.value = t("FEN copied")
        break
    }
  }

  function toolbarClick(index) {

    // trap that the button should be disabled but the screen hasn't caught up
    var element = findToolbarElement(toolbarElements.value,index)
    if (element != null && element.disabled)
      return

    if (showState.value == SHOW_GAMELIST) {
      toolbarGameListClick(index)
      return
    }
    switch (index) {
      
      case TOOLBAR_FLIP :
        resetSelections()
        incrementAppendTrigger()
        playingWhite = 1 - playingWhite
        orientation.value = (playingWhite == 1) ? "white" + blankAppendTrigger : "black" + blankAppendTrigger
        getMoves(0,0)
        break;
      case TOOLBAR_BACK :
        if (moveHistoryStack.value.length <= 1) {
          toolbarClick(TOOLBAR_REWIND)
        }
        else {
          moveHistoryStack.value.pop()
          moveHistoryTrigger.value++
          fen.value = moveHistoryStack.value[moveHistoryStack.value.length - 1].fen
          fenid = moveHistoryStack.value[moveHistoryStack.value.length - 1].fenid
          //console.log("**** back -> ",fenid,fen.value)
          getMoves(0,0)
        }
        break
      case TOOLBAR_REWIND :          
        fen.value = INITIAL_FEN + " "
        fenid = "1"
        moveHistoryStack.value = []
        moveHistoryTrigger.value++
        getMoves(0,0)
        break
      case TOOLBAR_GOTO_GAMELIST :

        // save board info for when coming back from gamelist.  
        savedAvailableMoves = availableMoves.value
        availableMoves.value = []
        boardOrientation = orientation.value
        savedFen = fen.value

        oneGameEvent.value = ""
        oneGameScore.value = ""
        oneGameMoves.value = []
        fen.value = INITIAL_FEN
        oneGamePlayingWhite = 1

        setToolbarElementDisabledFlag(toolbarElementsGameList,TOOLBAR_GAMELIST_BACK,true)
        setToolbarElementDisabledFlag(toolbarElementsGameList,TOOLBAR_GAMELIST_FORWARD,true)

        toolbarElements.value = toolbarElementsGameList
        // var element = findToolbarElement(toolbarElementsGameList,TOOLBAR_GAMELIST_DOWNLOAD)
        // element.submenu[TOOLBAR_GAMELIST_DOWNLOAD_CURRENT-10].disabled = true
        // element.submenu[TOOLBAR_GAMELIST_DOWNLOAD_FEN-10].disabled = true
        toolbarTrigger.value++

        showState.value = SHOW_GAMELIST
        getGames(0,0)
        break
    }
  }

  function movelistClick(arrayIndex) {
    fen.value = availableMoves.value[arrayIndex].fen
    fenid = availableMoves.value[arrayIndex].fenid
    const san = availableMoves.value[arrayIndex].san

    selectedSan = ""
    selectedFen = ""
    selectedFenid = 0
    showMoveListCheckboxes.value = "yes"

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GOTO_GAMELIST,true)

    toolbarTrigger.value++

    const oneMove = {fen : fen.value, fenid : fenid, san : san }
    moveHistoryStack.value.push(oneMove)
    moveHistoryTrigger.value++
    getMoves(0,0)
  }

  function resetSelections() {
    selectedSan = ""
    selectedFen = ""
    selectedFenid = 0
    selectedPlayerId = 0

    showMoveListCheckboxes.value = "yes"
    showPlayerCheckboxes.value = true

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GOTO_GAMELIST,true)
    toolbarTrigger.value++
  }

  function moveListCheckboxClick(item) {
    //console.log("move list checkbox in master explorer",item)
    if (item.flag) {
      const specificToFenid = availableMoves.value[item.index].fenid
      selectedSan = availableMoves.value[item.index].san
      selectedFen = availableMoves.value[item.index].fen
      selectedFenid = availableMoves.value[item.index].fenid
      selectedPlayerId = 0

      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GOTO_GAMELIST,
                  (availableMoves.value[item.index].totalCount <= 10000) ? false : true)

      toolbarTrigger.value++
      getMoves(0,specificToFenid)
    }
    else {
      resetSelections()

      processJsonResponse(saveJsonResponseFromServer)
      //getMoves(0,0)
    }
  }

  function playerClick(playerid,playerName) {
    //console.log("clicked playerid",playerid)

    selectedPlayerId = playerid
    selectedPlayerName = playerName

    // deselected, go back to all the moves
    if (playerid == 0) {

      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GOTO_GAMELIST,true)

      toolbarTrigger.value++

      showMoveListCheckboxes.value = "yes"
      
      processJsonResponse(saveJsonResponseFromServer)
    }
    else {
      showMoveListCheckboxes.value = "hide"

      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GOTO_GAMELIST,false)
      toolbarTrigger.value++

      getMoves(playerid,0)
    }
  }

  function tourDone() {
    showTour.value = false
  }

  function boardMove(arrayIndex,from,to) {
    movelistClick(arrayIndex)
  }
  
  function processJsonResponse (json) {
    const specificPlayerid = json['specific_playerid']
    const specificToFenid = json['specific_to_fenid']

    //console.log("in process json fenid and playerid",specificToFenid,specificPlayerid)
    const nothingSelected = (specificPlayerid == 0 && specificToFenid == 0)

    // build the move list

    if (specificPlayerid != 0 || nothingSelected) {
      availableMoves.value = []
      const whiteString = json['white']
      const blackString = json['black']
      const drawString = json['draw']
      const whites = whiteString.split("\t")
      const blacks = blackString.split("\t")
      const draws = drawString.split("\t")
      const sans = json['san'].split("\t")
      const totals = json['total'].split("\t")
      const totalCounts = json['totalcount'].split("\t")
      const scores = json['score'].split("\t")
      const fens = json['fen'].split("\t")
      const fenids = json['fenid'].split("\t")
      const froms = json['from'].split("\t")
      const tos = json['to'].split("\t")
      eighty.value = json['eighty']
      const count = json['count']
    
      const showMoveListCheckbox = (nothingSelected) ? "show" : undefined

      var tempData = []
      const moveColor = (playingWhite == 1) ? "w" : "b"
      for (var i=0; i < count; i++) {
        const oneMove = { index: i, fenid: fenids[i], white : whites[i], black : blacks[i], 
                          draw : draws[i], from : froms[i], to: tos[i],
                          san : sans[i], total : totals[i], totalCount : totalCounts[i],
                          score : scores[i], fen : fens[i],
                          repflagged : false, email : false}
        availableMoves.value.push(oneMove)
      }
      //console.log("available moves",availableMoves.value)
    }

    if (specificToFenid != 0 || nothingSelected) {
      //console.log("selected a specific FENID",specificToFenid,selectedSan,selectedFenid,selectedFen)

      const moveColorIsWhite = 1 - (moveHistoryStack.value.length % 2)
      playerNameHeadingString.value = (moveColorIsWhite == playingWhite) ? 
                            t("Moves Played By") : t("Moves Played Against")

      if (specificToFenid != 0) {
        showPlayerCheckboxes.value = false
        //playerNameHeadingString.value = "Playing -> " + selectedSan
      }
      else {
        showPlayerCheckboxes.value = true
        //playerNameHeadingString.value = "Playing all Moves"
      }

      // get the player names if on the first pass
      const nameCount = json['name_count']
      if (playerNames.length == 0 && nameCount > 0) {
        const ids = json['nameids'].split("\t")
        const names = json['names'].split("\t")
        const flags = json['flags'].split("\t")
        for (var i = 0; i < nameCount; i++) {
          const onePlayerName = { name : names[i], saveFlag : flags[i] == 1}
          playerNames["" + ids[i]] = onePlayerName
        }
      }

      // get the player list
      const playerCount = json['player_count']
      const playerGames = json['playergames'].split("\t")
      const playerIds = json['playerids'].split("\t")
      const playerRatings = json['playerratings'].split("\t")
      const playerRecentGames = json['playerrecents'].split("\t")
    
      players.value = []
      for (var i=0; i < playerCount; i++) {
        const onePlayer = { index : i, 
                            id : playerIds[i], 
                            idString : "" + playerIds[i],
                            name : playerNames["" + playerIds[i]].name,
                            games : parseInt(playerGames[i]),
                            rating : parseInt(playerRatings[i]), 
                            recent : playerRecentGames[i],
                            email :  ""}
        players.value.push(onePlayer)
      }
      playerListTrigger.value++
    }

    // update the toolbar
    const ply = moveHistoryStack.value.length
 
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,(ply >= 1) ? false : true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,(ply >= 1) ? false : true)

    toolbarTrigger.value++
  }
  
  function processJsonResponseFromServer(json) {
    //console.log(" in callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    //console.log("*** got json from server")
    
    const specificPlayerid = json['specific_playerid']
    const specificToFenid = json['specific_to_fenid']

    //console.log("in get from server fenid and playerid",specificToFenid,specificPlayerid)
    if (specificPlayerid == 0 && specificToFenid == 0)
      saveJsonResponseFromServer = json

    processJsonResponse(json)
  }

  function getMoves(specificPlayerid,specificToFenid) {

    if (specificPlayerid == 0)
      selectedPlayerId = 0
    if (specificToFenid == 0)
      selectedFenid = 0

    var forWhite = 1 - (moveHistoryStack.value.length % 2)
    if (playingWhite == 0)
      forWhite = 1 - forWhite
    forWhite = playingWhite

    var formData = {
      fenid : fenid,
      to_fenid : specificToFenid,
      id : specificPlayerid,
      p : moveHistoryStack.value.length,
      white : forWhite,
      timenow : (useAllGames) ? 0 : 1,
      emailflag : ""
    }

    if (fenid == 0)
      fenid = 1

    //console.log("zap available moves")
    
    // need to do something to avoid moves while processing but not this way
    // availableMoves.value = []
    //eighty.value = -2

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_BACK,true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_REWIND,true)

    //console.log("before post -> ",formData)

    useGetData("chessvis_master_next_ply.php", formData, processJsonResponseFromServer)
  }

  // STUFF FOR GAME LIST

  function gameClick(gameid,whiteName,blackName) {
    //console.log("clicked gameid",gameid)
    oneGameID = gameid
    oneGameWhiteName = whiteName
    oneGameBlackName = blackName
    // can download one game

    // var element = findToolbarElement(toolbarElements.value,TOOLBAR_GAMELIST_DOWNLOAD)
    // element.submenu[TOOLBAR_GAMELIST_DOWNLOAD_CURRENT-10].disabled = false
    getOneGame(gameid)
  }

  function toolbarGameListClick(index) {
    //console.log("gamelist click ",arrayIndex)
    // trap that the button should be disabled but the screen hasn't caught up

    var element = findToolbarElement(toolbarElements.value,index)
    if (element != null && element.disabled)
        return

    switch (index) {
      case TOOLBAR_GAMELIST_DOWNLOAD :
        alertInfo.value = { header : t("What to Download?") , 
                message : t("Download") + ":", type : "masterdownload", task : "masterdownload"  }
        alertTrigger.value++
        break
      case TOOLBAR_GAMELIST_SCORE :
        getEngineScores()
        break
      case TOOLBAR_GAMELIST_DONE :
        availableMoves.value = savedAvailableMoves
        orientation.value = boardOrientation
        showState.value = SHOW_EXPLORER
        incrementAppendTrigger()
        fen.value = savedFen + blankAppendTrigger
        toolbarElements.value = toolbarMainElements
        toolbarTrigger.value++
        break
      case TOOLBAR_GAMELIST_FLIP :
        incrementAppendTrigger()
        oneGamePlayingWhite = 1 - oneGamePlayingWhite
        orientation.value = (oneGamePlayingWhite == 1) ? "white" + blankAppendTrigger : "black" + blankAppendTrigger
        break
      case TOOLBAR_GAMELIST_BACK :
        directionTriggerCounter++
        directionTrigger.value = -directionTriggerCounter
        break
      case TOOLBAR_GAMELIST_FORWARD :
        directionTriggerCounter++
        directionTrigger.value = directionTriggerCounter
        break
    }
  }

  function processGameListJsonResponse(json) {
    //console.log("in gamelist callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const gameCount = json['count']
    const whiteNames = json['w_name'].split("\t")
    const blackNames = json['b_name'].split("\t")
    const whiteRatings = json['w_elo'].split("\t")
    const blackRatings = json['b_elo'].split("\t")
    const results = json['result'].split("\t")
    const dates = json['date'].split("\t")
    gamelistIdArray = json['id'].split("\t")

    games.value = []
      for (var i=0; i < gameCount; i++) {
        const onePlayer = { index : i, 
                            id : gamelistIdArray[i], 
                            white : whiteNames[i],
                            black : blackNames[i],
                            wrating : whiteRatings[i],
                            brating : blackRatings[i],
                            result : results[i],
                            date : dates[i]}
        games.value.push(onePlayer)
      }
      gameListTrigger.value++
  }

  function getGames() {

    var forWhite = 1 - (moveHistoryStack.value.length % 2)
    if (playingWhite == 0)
      forWhite = 1 - forWhite
    forWhite = playingWhite

    var formData = {
      fenid : fenid,
      to_fenid : selectedFenid,
      id : selectedPlayerId,
      p : moveHistoryStack.value.length,
      white : forWhite,
      timenow : (useAllGames) ? 0 : 1,
      emailflag : ""
    }

    //console.log("before gamelist post -> ",formData)

    games.value = []
    useGetData("chessvis_master_gamelist.php", formData, processGameListJsonResponse)
  }

  function gameMoveClick(index) {
    //console.log("In gamelist click",index)
    oneGameMoveIndex = index
    oneGameScore.value = oneGameMoves.value[index].score

    fen.value = (index == -1) ? INITIAL_FEN : oneGameMoves.value[index].fen

    var backDisabled = false
    var forwardDisabled = false
    if (index == -1)
      backDisabled = true
    else
    if (index >= oneGameMoves.value.length - 1)
      forwardDisabled = true

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GAMELIST_BACK,backDisabled)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GAMELIST_FORWARD,
                    forwardDisabled)

    toolbarGameListTrigger.value++
  }

  function processOneGameJsonResponse(json) {
    //console.log("in one game callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    oneGameEvent.value = json['event']
    const fens = json['fens'].split("\t")
    const sans = json['sans'].split("\t")
    const scores = json['scores'].split("\t")
    const score_types = json['score_types'].split("\t")
    const score_values = json['score_values'].split("\t")

    const whenScored = json['when_scored']
    scoreCount = json['score_count']
    plyCount = json['ply_count']

    //console.log("FENS",fens.length)
    //console.log("plys",plyCount)
    //console.log("scorecount",scoreCount)
    if (scoreCount >= plyCount) {
      oneGameScore.value = t("Entire Game Scored") 
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,true)
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,t("Game Scored"))
    }
    else {
      oneGameScore.value = Math.trunc(parseInt(scoreCount)/2 + .5) + " " + t("Moves Scored")
      const plysToScore = plyCount - scoreCount
      CalcScoreSeconds = Math.trunc(plysToScore / 4)
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,false)
      setToolbarElementLabel(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,
                      t("Calc Score") + "~" + CalcScoreSeconds + t("secs"))

    }
    oneGameMoves.value = Array(plyCount)
    var moveNumber = 0
    var moveNumberString = ""
    for (var i=0; i < plyCount; i++) {
      if ((i % 2) == 1)
        moveNumberString = ""
      else {
        moveNumber++
        moveNumberString = moveNumber + "."
      }
      const oneMove = { index : i,
                        fen : fens[i],
                        san : moveNumberString + sans[i],
                        score : (i < scoreCount) ? scores[i] : "not scored",
                        scoreType : (i < scoreCount) ? score_types[i] : "",
                        scoreValue : (i < scoreCount) ? score_values[i] : "",
                        selected : false
                      }
      oneGameMoves.value[i] = oneMove
    }

    //console.log("game moves",oneGameMoves.value)

    fen.value = INITIAL_FEN
    availableMoves.value = []

    // enable the forward button and download this game
  
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GAMELIST_BACK,true)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GAMELIST_FORWARD,false)

    // var element = findToolbarElement(toolbarElements.value,TOOLBAR_GAMELIST_DOWNLOAD)

    // element.submenu[TOOLBAR_GAMELIST_DOWNLOAD_CURRENT-10].disabled = false
    // element.submenu[TOOLBAR_GAMELIST_DOWNLOAD_FEN-10].disabled = false

    toolbarGameListTrigger.value++
    oneGameMoveIndex = -1
    //console.log("MOVES",oneGameMoves.value)
  }

  function getOneGame(gameid) {

    var formData = {
      masterid : gameid
    }

    //console.log("before one game post -> ",formData)

    useGetData("chessvis_one_master_game.php", formData, processOneGameJsonResponse)
  }

  function getDownloadPgn(gameid,filename) {

    var multiple = ""
    var single = ""
    if (gameid == 0)
      multiple = gamelistIdArray.join(",")
    else
      single = "" + gameid

    var formData = {
      m : multiple,
      s : single,
      name : filename
    }

    //console.log("before one game post -> ",formData)

    useGetDataDownload("chessvis_download_master_games.php", formData)
  }

  function startTimer() {

    function oneSecondInterval() {
      if (timerCanStop) {
        clearInterval(id)
        return
      }
      CalcScoreSeconds--
      if (CalcScoreSeconds <= 0) {
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,t("Still Scoring"))
        clearInterval(id)
      }
      else {
        setToolbarElementLabel(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,
                        t("Scoring") + " ~" + CalcScoreSeconds + t("secs"))

        toolbarGameListTrigger.value++
      }
    }
    var id = setInterval(oneSecondInterval, 1000)
  }

  function processEngineScoresJsonResponse(json) {
    timerCanStop = true
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,t("Done Scoring"))
    toolbarGameListTrigger.value++

    //console.log("run engine callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    // see if user gave on this game while calculating
    const returnMasterid = json['masterid']
    if (returnMasterid != oneGameID)
      return

    const scores = json['scores'].split("\t")

    for (var i=0; i < oneGameMoves.value.length; i++) {
      oneGameMoves.value[i].score = scores[i]
    }

  }

  function getEngineScores() {
    var fenArray = []
    var scoreTypes = []
    var scoreValues = []
    var scoreStrings = []
    for (var i=0; i < oneGameMoves.value.length; i++) {
      fenArray.push(oneGameMoves.value[i].fen)
      scoreTypes.push(oneGameMoves.value[i].scoreType)
      scoreValues.push(oneGameMoves.value[i].scoreValue)
      scoreStrings.push(oneGameMoves.value[i].score)

    }
    const fenString = fenArray.join("\t")
    const scoreTypeString = scoreTypes.join("\t")
    const scoreValueString = scoreValues.join("\t")
    const scoreDisplayString = scoreStrings.join("\t")

    const fenCount = fenArray.length

    var formData = {
      masterid : oneGameID,
      fen_count : fenCount,
      fen_string : fenString,
      score_type : scoreTypeString,
      score_value : scoreValueString,
      score_display : scoreDisplayString,
      score_count : scoreCount
    }

    //console.log("before run engine scores post -> ",formData)
    setToolbarElementLabel(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,
                      t("Scoring") + " ~" + CalcScoreSeconds + t("secs"))

    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_GAMELIST_SCORE,true)
    toolbarGameListTrigger.value++
    timerCanStop = false
    startTimer()

    useGetData("chessvis_master_run_engine.php", formData, processEngineScoresJsonResponse)
  }

</script>

<style>

#explorer-container {
  position : relative;
}


.game-review-event {
  display: inline-block;
  width : 75%;
  text-align: left;
}

.game-review-score {
  display: inline-block;
  width : 25%;
  text-align: right;
}

#game-event-container {
  position : relative;
  line-height : 1.5em;
}

.reptree-container-background-dark {
  background-color: #403726;
}

.reptree-container-background-light {
  background-color : #ebf2f2;
}

</style>
